import React from 'react';
import AggregatePercentageGraph from './AggregatePercentageGraph';
import PracticeAreaCharacterizationGraph from './PracticeAreaCharacterizationGraph';
import SkeletonWrapper from '../skeleton/SkeletonWrapper';
import Nbsp from '../Nbsp';
import PracticeAreaGraphDescription from './PracticeAreaGraphDescription';

/**
 * @typedef {object} PracticeAreaGraphListProps
 * @property {Array<Object>} [practiceAreas]
 * @property {Array<Object>} [requestedReports]
 * @property {(data: import('recharts').BarRectangleItem) => void} [handlePracticeClick]
 * @property {boolean} [isPercentageVisible]
 * @property {number} [requestedReportCount]
 * @property {boolean} loading
 */

/**
 * @param {PracticeAreaGraphListProps} props
 */
const PracticeAreaGraphList = props => {
  const {
    requestedReports,
    practiceAreas,
    loading,
    handlePracticeClick,
    requestedReportCount = 1,
    isPercentageVisible = true
  } = props;

  const isOhtFilterExist =
    requestedReports &&
    requestedReports.length &&
    requestedReports.some(x => x.ohts && x.ohts.length);

  const isDeviceClassesFilterExist =
    requestedReports &&
    requestedReports.length &&
    requestedReports.some(x => x.deviceClasses && x.deviceClasses.length);

  const renderGraphData = (pa, index) => {
    const ohts = isOhtFilterExist ? requestedReports[index].ohts : null;
    const deviceClasses = isDeviceClassesFilterExist ? requestedReports[index].deviceClasses : null;
    return (
      <div key={index} className='baseline-reports__practice-area'>
        <div className='baseline-reports__graph-name'>
          <span className='baseline-reports__graph-name--bold'>
            Table {index + 1}
            <Nbsp />
          </span>
          <SkeletonWrapper
            show={loading}
            inheritParentSize={true}
            renderComponent={() => (
              <PracticeAreaGraphDescription
                practiceArea={pa}
                ohts={ohts}
                deviceClasses={deviceClasses}
              />
            )}
          />
        </div>
        <div className='baseline-reports__graph-group'>
          <PracticeAreaCharacterizationGraph
            practiceArea={pa}
            practiceClick={handlePracticeClick}
            loading={loading}
          />
          {isPercentageVisible && <AggregatePercentageGraph practiceArea={pa} loading={loading} />}
        </div>
      </div>
    );
  };

  if (loading) {
    return Array.from({ length: requestedReportCount }, (_, index) => renderGraphData(null, index));
  }

  return practiceAreas.map((pa, index) => renderGraphData(pa, index));
};

export default PracticeAreaGraphList;
